<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
    top
  >
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <v-card style="background-color: #f9f9f9">
      <v-card-actions style="background-color: #f9f9f9">
        <v-text-field
          v-model="topValue"
          class="caption"
          type="number"
          suffix="px"
          label="top"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-text-field
          v-model="rightValue"
          class="caption"
          type="number"
          suffix="px"
          label="right"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-text-field
          v-model="bottomValue"
          class="caption"
          type="number"
          suffix="px"
          label="bottom"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-text-field
          v-model="leftValue"
          class="caption"
          type="number"
          suffix="px"
          label="left"
          outlined
          hide-details
          dense
        ></v-text-field>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'EditPaddingMenu',
  props: {
    top: {
      type: Number,
      required: true
    },
    right: {
      type: Number,
      required: true
    },
    bottom: {
      type: Number,
      required: true
    },
    left: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    topValue: {
      get () {
        return this.top
      },
      set (value) {
        this.$emit('update-top', value)
      }
    },
    rightValue: {
      get () {
        return this.right
      },
      set (value) {
        this.$emit('update-right', value)
      }
    },
    bottomValue: {
      get () {
        return this.bottom
      },
      set (value) {
        this.$emit('update-bottom', value)
      }
    },
    leftValue: {
      get () {
        return this.left
      },
      set (value) {
        this.$emit('update-left', value)
      }
    }
  }
}
</script>
